var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "flex flex-col items-center gap-4 p-4 bg-upload-grey rounded-md border border-dashed cursor-pointer w-full",
        class: { "border-primary": _vm.isDragging },
        on: {
          click: _vm.addFile,
          dragover: function ($event) {
            $event.preventDefault()
            return _vm.onDragOver.apply(null, arguments)
          },
          dragleave: function ($event) {
            $event.preventDefault()
            return _vm.onDragLeave.apply(null, arguments)
          },
          drop: function ($event) {
            $event.preventDefault()
            return _vm.onDrop.apply(null, arguments)
          },
        },
      },
      [
        _c("UploadBoxIcon", { staticClass: "h-12 w-12" }),
        _c(
          "div",
          {
            staticClass: "flex flex-col items-center gap-1 self-stretch w-full",
          },
          [
            _c("p", { staticClass: "self-stretch text-center" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.processing
                      ? "Uploading..."
                      : "Click or drag file to this area to upload"
                  ) +
                  " "
              ),
            ]),
            _c(
              "p",
              { staticClass: "self-stretch text-center text-sub-heading" },
              [_vm._v(" Support for a single or bulk upload. ")]
            ),
          ]
        ),
      ],
      1
    ),
    _c("input", {
      ref: "fileInput",
      staticClass: "hidden",
      attrs: { name: "upload", type: "file", tabindex: "0" },
      on: {
        change: _vm.fileChange,
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }